<template>
    <div>
        <div id="page">
            <Header></Header>
        <div class="pro-hd">
            <van-swipe class="pro-hd-pic" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="item in house_info.project_picture"><img :src="downPath + item" alt=""></van-swipe-item>
            </van-swipe>
            <div class="pro-hd-txt">
                <div class="fix">
                    <div class="price">{{ house_info.rent_sale_price }}</div>
                    <div class="name">{{ house_info.house_name }}</div>
                </div>
                <div class="fix">
                    <div class="bar bshare-custom">
                        <span v-if="house_info.iscollect==0" class="keep" @click="keepHouse">收藏</span>
                        <span v-else-if="house_info.iscollect==1" class="keep on" @click="unKeepHouse">收藏</span>
                        <a title="更多平台" class="share bshare-more bshare-more-icon more-style-addthis"  @click="showTip = true">分享</a>
                    </div>
                    <div class="tagsw01"><span v-for="item in house_info.labels"><router-link :to="{path: 'searchResult', query: {key: item.label}}">{{ item.label }}</router-link></span></div>
                </div>
            </div>
        </div>
        <div class="pro-kfs" v-if="house_info.creator_id != 0">
            <div class="pic"><img :src="downPath + companyInfo.avatar" alt=""></div>
            <div class="txt">
                <div class="name">{{ companyInfo.company_name }}</div>
                <telConfirm class="tel" :tel="companyInfo.re_mobile400" :note="companyInfo.mobile400" :type="2"></telConfirm>
                <div class="tagsw01">
                    <span v-if="companyInfo.job!=null">{{ companyInfo.job }}</span>
                    <span v-if="companyInfo.isfocus == 0" @click="addFocus">关注</span>
                    <span v-else-if="companyInfo.isfocus == 1" @click="delFocus">已关注</span>
                </div>
            </div>
        </div>
        <div class="pro-info">
            <div class="item"><div class="lab">销售面积:</div><div class="val">{{ houseDetial.area }} ㎡</div></div>
            <div class="item"><div class="lab">楼盘名称:</div><div class="val">{{ houseDetial.building_input_name }}</div></div>
            <div class="item"><div class="lab">付款方式:</div><div class="val">{{ houseDetial.pay_way }}</div></div>
            <div class="item"><div class="lab">可否注册:</div><div class="val">{{ houseDetial.can_register }}</div></div>
            <div class="item"><div class="lab">价格包含:</div><div class="val">{{ houseDetial.price_contains }}</div></div>
            <div class="item w100"><div class="lab">项目地址:</div><div class="val">{{ houseDetial.address }}</div></div>
            <div class="item w100"><div class="lab">佣金政策:</div><div class="val">{{ houseDetial.commission_policy }}</div></div>
        </div>
        <div class="btn-block" @click="morePop = true"><span>更多房源信息</span></div>
        <div class="gridw01">
            <div class="gridw01-tit">交通配套</div>
            <div class="mapbox">
                <div class="keyList">
                    <div class="item" v-for="(item, index) in keyList" @click="mapKey = keyList[index]">{{ item }}</div>
                </div>
                <baidu-map class="map" :center="mapInfo.center" :zoom="mapInfo.zoom">
                    <bm-marker :position="mapInfo.center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
                    <bm-circle :center="mapInfo.center" :radius="mapInfo.radius"></bm-circle>
                    <bm-local-search :keyword="mapKey" :nearby="mapInfo" :auto-viewport="true" :panel="false"></bm-local-search>
                </baidu-map>
            </div>
        </div>
        <div class="gridw01">
            <div class="gridw01-tit">房源信息</div>
            <div class="gridw01-bd">
                <div class="listw01-item" v-for="item in changfang_house_info">
                    <div class="listw01-item-pic"><router-link :to="{path: 'house', query: {id: item.house_id}}"><img :src="item.main_img" alt=""></router-link></div>
                    <div class="listw01-item-txt">
                        <router-link :to="{path: 'house', query: {id: item.house_id}}">
                            <div class="listw01-item-name">{{ item.house_name }}</div>
                            <div class="listw01-item-info"><div class="lab">地址：</div><div class="val">{{ item.address }}</div></div>
                            <div class="listw01-item-info"><div class="lab">面积：</div><div class="val">{{ item.area }} ㎡</div></div>
                            <div class="listw01-item-price">价格：{{ item.rent_sale_price }}</div>
                        </router-link>
                        <div class="listw01-item-tags"><span v-for="sub in item.labels"><router-link :to="{path: 'searchResult', query: {key: sub.label}}">{{ sub.label }}</router-link></span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-block"><span><span @click="getmore">更多房源信息</span></span></div>
        <div class="gridw01" v-if="dynamic_info_list.length > 0">
            <div class="gridw01-tit">项目动态</div>
            <div class="gridw01-bd">
                <div class="listw04-item" v-for="item in dynamic_info_list">
                    <router-link :title="{path: 'DetailInfoView', query: {id: item.info_id}}">
                        <div class="listw04-item-pic"><img :src="downPath + item.thumbnail" alt=""></div>
                        <div class="listw04-item-txt">
                            <div class="title">{{ item.title }}</div>
                            <div class="info"><span>{{ item.author }}</span><span>{{ item.create_time }}</span></div>
                            <div class="desc">{{ item.content }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="btn-block" v-if="dynamic_info_list.length > 0"><span></span></div>
        <div class="gridw01" v-if="housePushList.length > 0">
            <div class="gridw01-tit">推荐房源</div>
            <div class="gridw01-bd">
                <div class="listw01-item" v-for="item in housePushList">
                    <div class="listw01-item-pic"><router-link :to="{path: 'house', query: {id: item.house_id}}"><img :src="item.main_img" alt=""></router-link></div>
                    <div class="listw01-item-txt">
                        <router-link :to="{path: 'house', query: {id: item.house_id}}">
                            <div class="listw01-item-name">{{ item.house_name }}</div>
                            <div class="listw01-item-info"><div class="lab">地址：</div><div class="val">{{ item.address }}</div></div>
                            <div class="listw01-item-info"><div class="lab">面积：</div><div class="val">{{ item.area }}㎡</div></div>
                            <div class="listw01-item-price">价格：{{ item.rent_sale_price }}</div>
                        </router-link>
                        <div class="listw01-item-tags"><span v-for="sub in item.labels"><router-link :to="{path: 'searchResult', query: {key: sub.label}}">{{ sub.label }}</router-link></span></div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <Footer></Footer>

        <van-popup v-model="morePop">
            <div class="pop-info">
                <div class="close" @click="morePop = false"></div>
                <div class="pro-info">
                    <h3>项目情况</h3>
                    <div class="items">
                        <h4>基本情况</h4>
                        <div class="item"><div class="lab">楼盘名称:</div><div class="val">{{ houseDetial.building_input_name }}</div></div>
                        <div class="item"><div class="lab">项目地址:</div><div class="val">{{ houseDetial.address }}</div></div>
                        <div class="item"><div class="lab">地铁线路:</div><div class="val">{{ houseDetial.subway_steps }}</div></div>
                        <div class="item"><div class="lab">租售形式:</div><div class="val">{{ houseDetial.rent_sale_formal }}</div></div>
                        <div class="item"><div class="lab">租售价格:</div><div class="val">{{ houseDetial.rent_sale_price }}</div></div>
                        <div class="item"><div class="lab">所处商圈:</div><div class="val">{{ houseDetial.districtname }}</div></div>
                        <div class="item"><div class="lab">可入驻时间:</div><div class="val">{{ houseDetial.re_in_time }}</div></div>
                        <div class="item"><div class="lab">销售状态:</div><div class="val">{{ houseDetial.sales_status }}</div></div>
                        <div class="item"><div class="lab">可否注册:</div><div class="val">{{ houseDetial.can_register }}</div></div>
                        <div class="item"><div class="lab">招商电话:</div><div class="val">{{ houseDetial.mobile400 }}</div></div>
                        <div class="item"><div class="lab">价格包含:</div><div class="val">{{ houseDetial.price_contains }}</div></div>
                        <div class="item"><div class="lab">付款方式:</div><div class="val">{{ houseDetial.pay_way }}</div></div>
                    </div>
                    <div class="items">
                        <h4>价格说明</h4>
                        <div class="item"><div class="val">{{ houseDetial.price_explain }}</div></div>
                    </div>
                    <div class="items">
                        <h4>物业信息</h4>
                        <div class="item"><div class="lab">物业公司:</div><div class="val">{{ houseDetial.wy_wuye_info_company }}</div></div>
                        <div class="item"><div class="lab">停车位:</div><div class="val">{{ houseDetial.wy_parking_count }}</div></div>
                        <div class="item"><div class="lab">物业费:</div><div class="val">{{ houseDetial.wy_wuyefei }}</div></div>
                    </div>
                    <div class="items">
                        <h4>产品类型</h4>
                        <div class="item"><div class="lab">项目特色:</div><div class="val">{{ houseDetial.features }}</div></div>
                        <div class="item"><div class="lab">租售面积:</div><div class="val">{{ houseDetial.area }} ㎡</div></div>
                        <div class="item"><div class="lab">楼层数:</div><div class="val">{{ houseDetial.floors_number }}</div></div>
                        <div class="item"><div class="lab">标准层高:</div><div class="val">{{ houseDetial.standard_high }}</div></div>
                        <div class="item"><div class="lab">装修状况:</div><div class="val">{{ houseDetial.decorate_status }}</div></div>
                        <div class="item"><div class="lab">政策类型:</div><div class="val">{{ houseDetial.policy_type }}</div></div>
                        <div class="item"><div class="lab">园区级别:</div><div class="val">{{ houseDetial.park_level }}</div></div>
                        <div class="item"><div class="lab">园区服务:</div><div class="val">{{ houseDetial.park_service }}</div></div>
                    </div>
                    <div class="items">
                        <h4>项目介绍</h4>
                        <div class="item"><div class="val">{{ houseDetial.description }}</div></div>
                    </div>
                </div>
            </div>
        </van-popup>

        <div class="share-tip" v-show="showTip" @click="showTip = false">
            <img src="../assets/images/share-tip.png" alt="">
        </div>

    </div>

</template>

<script>

    import telConfirm from '@/components/TelConfirm'
    import wx from 'weixin-js-sdk'
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { Popup, Swipe, SwipeItem, Toast } from 'vant'
	import {mapState} from 'vuex'
    export default {
        name: "House",
        data: function(){
            return {
                showTip: false,
                morePop: false,
                mapInfo: {
                    center: {lng: 116.405419, lat: 39.915156},
                    zoom: 14,
                    radius: 1000,
                },
                keyList: ['公交', '地铁', '超市', '餐饮', '酒店', '金融', '住宅', '物流'],
                mapKey: '',
                downPath: '',
                housePushList: [],
                changfang_house_info: [],
                house_info: {},
                houseDetial: {},
                companyInfo: {},
                dynamic_info_list: []
            }
        },
        components: {
            Header, Footer, telConfirm,
            [Popup.name]: Popup,
            [Swipe.name]: Swipe,
            [Toast.name]: Toast,
            [SwipeItem.name]: SwipeItem
        },
        mounted(){
            this.downPath = this.api.downPath;
            this.getView();
            this.getDetail();
        },
		computed:{
			...mapState(['cityList'])
		},
        methods: {
			getmore(){
				
				let citydata=this.cityList.filter(item=>{
					return item.id==this.houseDetial.city_id
				})
				
				if(this.houseDetial.url_screen==1){
					
					this.$store.commit('setActiveAddr', citydata[0].name);
					this.$store.commit('changeActiveAddr', citydata[0]);
					
					
					this.$router.push({
						path:'/houseList',
						query:{houseDetial:JSON.stringify(this.houseDetial)}
					})
					
					
				}else{
					this.$router.push({
						path:'/houseList'
						
					})
				}
				
				
				
				
			},
            getView(){
                const _this = this;
                _this.api.getHouseView({house_id: _this.$route.query.id}).then(function(response){
                    response.companyInfo.re_mobile400 = response.companyInfo.mobile400.split('转')[0];
                    _this.housePushList = response.housePushList;
                    _this.changfang_house_info = response.changfang_house_info;
                    _this.house_info = response.house_info;
					
					let city=_this.cityList.filter(item=>{
						return item.id===response.house_info.city_id
					})
					
					_this.$store.commit('setActiveAddr', city[0].name);
					
					_this.$store.commit('changeActiveAddr', city[0]);
					
                    _this.companyInfo = response.companyInfo;
                    _this.dynamic_info_list = response.dynamic_info_list;
                    setTimeout(function(){
                        _this.mapInfo.center.lng = response.house_info.longitude;
                        _this.mapInfo.center.lat = response.house_info.latitude
                    }, 100);
                    _this.getShareConfig();
                })
            },
            getDetail(){
                const _this = this;
                _this.api.getHouseDetail({house_id: _this.$route.query.id}).then(function(response){
                    _this.houseDetial = response;
                    _this.houseDetial.re_in_time = _this.formatTime(_this.houseDetial.in_time, '{y}-{m}-{d}')
                })
            },
            setShare(){
                const s1 = document.createElement('script');
                const s2 = document.createElement('script');
                s1.type = 'text/javascript';
                s2.type = 'text/javascript';
                s1.src = 'http://static.bshare.cn/b/buttonLite.js#style=-1&uuid=&pophcol=2&lang=zh';
                s2.src = 'http://static.bshare.cn/b/bshareC0.js';
                document.body.appendChild(s1);
                document.body.appendChild(s2);
            },
            keepHouse(){
                const _this = this;
                let params = new FormData();
                params.append('id', _this.house_info.house_id);
                params.append('type', 'house');
                _this.api.addCollection(params).then(function(response){
                    Toast(response.msg);
                    _this.getView();
                })
            },
            unKeepHouse(){
                const _this = this;
                let params = new FormData();
                params.append('collection_id', _this.house_info.collection_id);
                _this.api.delCollection(params).then(function(response){
                    Toast(response.msg);
                    _this.getView();
                })
            },
            addFocus(){
                const _this = this;
                let params = new FormData();
                params.append('member_id', _this.companyInfo.member_id);
                _this.api.addFocus(params).then(function(response){
                    Toast(response.msg);
                    _this.getView();
                })
            },
            delFocus(){
                const _this = this;
                let params = new FormData();
                params.append('focus_id', _this.companyInfo.focus_id);
                _this.api.delFocus(params).then(function(response){
                    Toast(response.msg);
                    _this.getView();
                })
            },
            getShareConfig(){
                const _this = this;
                _this.api.getShareConfig({
                    url: window.location.href.split('#')[0],
                    target: 'house',
                    id: _this.$route.query.id
                }).then(function(response){
                    const result = response;
                    wx.config({
                        debug: false,
                        appId: result.appId,
                        timestamp: result.timestamp,
                        nonceStr: result.nonceStr,
                        signature: result.signature,
                        jsApiList: [
                            'updateAppMessageShareData',
                            'updateTimelineShareData'
                        ]
                    });
                    var link = '';
                    var u = navigator.userAgent, app = navigator.appVersion;
                    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                    if (isAndroid) {
                        link = window.location.href.split('#')[0] + '?#' + window.location.href.split('#')[1]
                    }
                    if (isIOS) {
                        link = window.location.href.split('#')[0] + '#' + window.location.href.split('#')[1]
                    }
                    wx.error(function (res) {
                        console.log('验证失败返回的信息:',res.errMsg);
                    });
                    wx.ready(function () {
                        const imgUrl = _this.house_info.project_picture[0];
                       
                        // 分享给朋友
                        wx.updateAppMessageShareData({
                            title: _this.house_info.house_name+'-'+_this.houseDetial.sales_status, // 分享标题
                            desc: _this.houseDetial.address+_this.houseDetial.rent_sale_price, // 分享描述
                            link: link,
                            imgUrl: imgUrl, // 分享图标
                            success: function () {}
                        });

                        // 分享到朋友圈
                        wx.updateTimelineShareData({
                            title: _this.house_info.house_name+'-'+_this.houseDetial.sales_status, // 分享标题
                            desc: _this.houseDetial.address+_this.houseDetial.rent_sale_price, // 分享描述
                            link: link,
                            imgUrl,
                            success: function () {}
                        });
                    });
                })
            }
        },
        watch: {
            $route: function(){
                this.getView();
                this.getDetail();
            }
        }
    }
</script>

<style scoped>
    .gridw01 {margin-bottom: .2rem;}
    .listw01-item:last-child {border-bottom: none;}

</style>